const rootVars = window?.getComputedStyle(document.documentElement);

export const MAIN_THEME = {
  color: {
    // System Colors
    red: rootVars.getPropertyValue('--red'),
    green: rootVars.getPropertyValue('--green'),
    orange: rootVars.getPropertyValue('--orange'),
    black: rootVars.getPropertyValue('--black'),
    black25: rootVars.getPropertyValue('--black25'),
    black47: rootVars.getPropertyValue('--black47'),
    white65: rootVars.getPropertyValue('--white65'),
    white86: rootVars.getPropertyValue('--white86'),
    white92: rootVars.getPropertyValue('--white92'),
    white98: rootVars.getPropertyValue('--white98'),
    white: rootVars.getPropertyValue('--white'),

    // Special Widgets Colors
    blue: rootVars.getPropertyValue('--blue'),
    darkBlue: rootVars.getPropertyValue('--darkBlue'),
    darkRed: rootVars.getPropertyValue('--darkRed'),
    currencyGreen: rootVars.getPropertyValue('--currencyGreen'),
    currencyLightGreen: rootVars.getPropertyValue('--currencyLightGreen'),
    currencyBlue: rootVars.getPropertyValue('--currencyBlue'),
    currencyLightBlue: rootVars.getPropertyValue('--currencyLightBlue'),
  },
  font: {
    regular: rootVars.getPropertyValue('--primaryFontRegular'),
    medium: rootVars.getPropertyValue('--primaryFontMedium'),
    bold: rootVars.getPropertyValue('--primaryFontBold'),
  },
  fontSize: {
    // rem is used to ensure that the font size is responsive
    // this should be used for text only
    xs: '0.75rem', // 12px
    sm: '0.875rem', // 14px
    rg: '1rem', // 16px
    md: '1.125rem', // 18px
    lg: '1.25rem', // 20px
    xl: '1.5rem', // 24px
    xxl: '1.75rem', // 28px
  },
  size: {
    // px is used to ensure that the size is fixed
    // this should be used for padding, margin, width, height, etc.
    xs: '12px',
    sm: '14px',
    rg: '16px',
    md: '24px',
    lg: '32px',
    xl: '48px',
  },
};

export const HEADER_HEIGHT = 60;
